import { BaseDto } from "./base.dto";

export class EmployeeMobileInfoDto extends BaseDto {
    id: number;
    firstName: string;
    lastName?: string;
    knownAs?: string;
    employeeNumber?: string;
    merchantName: string;
    costCentreName: string;  
    isActive?: boolean;
    startDate: Date;
    endDate?: Date;
}